import React from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import { Footer, HeaderODS } from "theme/component";

import classes from "./LayoutWrapper.module.scss";
import { Loader } from "shared/components";

const LayoutWrapper = ({ backgroundColor }) => (
	<div style={{ backgroundColor }} className={classes.layout}>
		<header>
			<HeaderODS />
		</header>
		<main role="main" className={classes.contentContainer}>
			<div className={classes.content}>
				<Outlet />
				<Loader />
			</div>
		</main>
		<footer className={classes.footer}>
			<Footer />
		</footer>
	</div>
);

LayoutWrapper.propTypes = {
	backgroundColor: PropTypes.string
};

LayoutWrapper.defaultProps = {
	backgroundColor: "var(--color-white)"
};

export default LayoutWrapper;
